import React, { useState } from 'react';
import { toast } from 'react-toastify';

import TextAreaModal from 'components/Modals/textAreaModal';
import { IconButtonContainer, ButtonIcon } from './styles';
import services from 'api/services';

const { CommentService } = services;

export default function FreecodeReportModal({ test, contest }) {
  const [displayReportModal, setDisplayReportModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submitReport = async (feedback) => {
    try {
      setSubmitting(true);
      const reportResult = await CommentService.reportComment({ test: test._id, contest: contest?._id, feedback });
      if (reportResult?._id) {
        toast.success('Report Submitted');
        setDisplayReportModal(false);
      } else {
        toast.error('Report did not return expected value');
      }
    } catch (error) {
      if (typeof error?.message === 'string') {
        toast.error(error.message);
      } else if (error?.message instanceof Array && error.message.length) {
        toast.error(error.message[0]);
      } else {
        toast.error('Failed to submit report');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <IconButtonContainer title="Report a problem" onClick={() => setDisplayReportModal(!displayReportModal)}>
        <ButtonIcon icon="fa fa-fire-extinguisher"></ButtonIcon>
      </IconButtonContainer>
      {displayReportModal && (
        <TextAreaModal
          title="Report A Problem"
          loading={submitting}
          onCancel={() => setDisplayReportModal(false)}
          onSubmit={submitReport}
          placeholder="Write your report here"
        />
      )}
    </>
  );
}
